import { Link } from "react-router-dom";
import styles from "./ScheduledForMergeBadge.module.css";

type ScheduledForMergeBadgeProps = {
  label: string;
  href: string;
};

export function ScheduledForMergeBadge({ label, href }: ScheduledForMergeBadgeProps) {
  return (
    <Link to={href} className={styles.badge} onClick={event => event.stopPropagation()}>
      {label}
      <span aria-hidden="true" className={styles.chevron}>
        ›
      </span>
    </Link>
  );
}
